import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const langMap: {[id: string]: Array<string>} = {
    "settings": ["Settings", "Inställningar"],
    "starting-video": ["Starting video", "Startar video"],
    "starting-camera": ["Starting camera", "Startar kamera"],
    "starting-network": ["Starting network", "Startar nätverk"],
    "booked-meetings": ["Booked meetings", "Bokade möten"],
    "previous-meetings": ["Previous meetings", "Tidigare möten"],
    "coming": ["Upcoming", "Kommande"],
    "earlier": ["Earlier", "Tidigare"],
    "previous": ["Previous", "Föregående"],
    "calendar": ["Calendar", "Kalender"],
    "start": ["Start", "Start"],
    "my-bookings": ["My bookings", "Mina bokningar"],
    "meetings": ["Meetings", "Möten"],
    "menu-support": ["Support", "Support"],
    "menu-about-company": ["About Zebrain", "Om Zebrain"],
    "logout": ["Log out", "Logga ut"],
    "about-nav-title": ["About Zebrain", "Om Zebrain"],
    "support-nav-title": ["Support", "Support"],
    "support-description-placeholder": ["Describe your issue here...", "Beskriv ditt problem här..."],
    "support-email-info": ["You can also email us at", "Du kan också mejla oss på"],
    "set-availability": ["Set availability", "Ställ in tillgänglighet"],
    "set-hours-per-day": ["Set hours per day", "Ställ in timmar per dag"],
    "availability": ["Availability", "Tillgänglighet"],
    "availability-timeperiod": ["Time period for availability", "Tidsperiod för tillgänglighet"],
    "availability-timeperiod-set": ["Set for how long your schedule lasts", "Ställ in hur länge ditt schema ska gälla"],
    "number-of-weeks": ["Number of weeks", "Antal veckor"],
    "standard-schedule": ["Standard schedule", "Ordinarie schema"],
    "deviant-schedule": ["Deviant dates", "Avvikande datum"],
    "schedule": ["Schedule", "Schema"],
    "other-settings": ["Other settings", "Övriga inställningar"],
    "sync-external-calendar": ["Sync external calendar", "Synka extern kalender"],
    "add-extra-availability": ["Add extra availability", "Lägg till extra tillgänglighet"],
    "add": ["Add", "Lägg till"],
    "block-time-dates": ["Block time and dates", "Blockera tider och datum"],
    "cancel": ["Cancel", "Avbryt"],
    "save": ["Save", "Spara"],
    "delete": ["Delete", "Ta bort"],
    "hours": ["hours", "timmar"],
    "minutes": ["minutes", "minuter"],
    "extra-availability-text": [
      "You can choose multiple dates. Selected dates overrules the standard schedule.",
      "Du kan välja flera datum samtidigt. Valda datum åsidosätter standardschemat."
    ],
    "time-before-booking": ["Booking-to-Meeting Buffer", "Tid mellan ny bokning och mötets start"],
    "time-before-booking-set": [
      "Select the minimum time gap between a new booking and the meeting start.",
      "Ange den minsta tidsmarginalen mellan en ny bokning och mötesstart."
    ],
    "time-head": ["Time ahead", "Tid i förväg"],
    "start-interval": ["Start interval", "Startintervall"],
    "start-interval-set": ["Set start interval for meetings", "Ställ in startintervall för möten"],
    "time-interval": ["Time interval", "Tidsintervall"],
    "max-bookings": ["Daily booking limit", "Max antal bokningar per dag"],
    "max-bookings-set": [
      "Select the maximum number of bookings allowed per day",
      "Ställ in det maximala antalet bokningar per dag"
    ],
    "max-per-day": ["Max per day", "Max per dag"],
    "buffer-time": ["Meeting-to-Meeting buffer", "Bufferttid"],
    "buffer-time-set": [
      "Select the minimum time gap between consecutive meetings",
      "Ställ in den minsta pausen efter ett möte innan nästa kan börja."
    ],
    "my-clients": ["My clients", "Mina klienter"],
    "my-profile": ["My profile", "Min profil"],
    "language": ["Language", "Språk"],
    "languages": ["Languages", "Språk"],
    "select-language": ["Select language", "Välj språk"],
    "select": ["Select", "Välj"],
    "choose-coaching-language": ["Choose language to coach in", "Välj språk att coacha på"],
    "profile-intro": ["Short about your self as coach", "Kort om dig som coach"],
    "profile-expertise": ["Expertise", "Expertis"],
    "profile-experience": ["Experience", "Erfarenhet"],
    "profile-philosophy": ["Philosophy", "Filosofi"],
    "no-meetings-today": ["You have no meetings today.", "Du har inga möten idag."],
    "one-meeting-today": ["You have one meeting today.", "Du har ett möte idag."],
    "you-have": ["You have ", "Du har"],
    "meetings-today": ["meetings booked today", "möten inbokade idag"],
    "cs": ["Czech", "Tjeckiska"],
    "no": ["Norwegian", "Norska"],
    "nl": ["Ductch", "Holländska"],
    "el": ["Greek", "Grekiska"],
    "hu": ["Hungarian", "Ungerska"],
    "pl": ["Polish", "Polska"],
    "pt": ["Portuguese", "Portugisiska"],
    "es": ["Spanish", "Spanska"],
    "sv": ["Swedish", "Svenska"],
    "fi": ["Finnish", "Finska"],
    "en": ["English", "Engelska"],
    "de": ["German", "Tyska"],
    "fr": ["French", "Franska"],
    "da": ["Danish", "Danska"],
    "it": ["Italian", "Italienska"],
    "change": ["Change", "Ändra"],
    "go-to-meeting": ["Go to meeting", "Gå till mötet"],
    "to-meeting": ["To meeting", "Till möte"],
    "cancel-booking": ["Cancel", "Avboka"],
    "today": ["Today", "Idag"],
    "next-meeting": ["Next meeting", "Nästa möte"],
    "next": ["Next", "Nästa"],
    "hi": ["Hi", "Hej"],
    "add-more-availability": ["Set availability", "Ställ in tillgänglighet"],
    "complete-profiles": ["Complete profiles", "Färdigställ profiler"],
    "go-to-profile": ["Go to My profile", "Gå till Min profil"],
    "go-to-availability": ["Go to Availability settings", "Gå till Tillgänglighet"],
    "original-booking": ["Original booking", "Ursprunglig bokning"],
    "your-meeting-has": ["Your meeting has", "Ditt möte har"],
    "client-is-notified": ["and your client is notified", "och din klient har meddelats"],
    "coach-is-notified": ["and your coach is notified", "och din coach har meddelats"],
    "write-message-to-client": ["Write a message to the client...", "Skriv ett meddelande till klienten..."],
    "write-message-to-coach": ["Write a message to the coach...", "Skriv ett meddelande till coachen..."],
    "been-changed": ["been changed", "ändrats"],
    "been-booked": ["been booked", "bokats"],
    "book-meeting": ["Book meeting", "Boka möte"],
    "change-meeting": ["Change meeting", "Ändra möte"],
    "cancel-meeting": ["Cancel meeting", "Avboka möte"],
    "available-times": ["Available times", "Lediga tider"],
    "development-plan": ["Development plan", "Utvecklingsplan"],
    "read": ["Read", "Läs"],
    "professional-details": ["Professional details", "Yrkesdetaljer"],
    "level": ["Level", "Nivå"],
    "in-company-since": ["In company since", "I företaget sedan"],
    "current-role-since": ["Current role since", "Nuvarande roll sedan"],
    "non-managerial": ["Non-managerial employee", "Anställd utan ledande befattning"],
    "manager_team": ["Manager with team and/or personnel responsibility", "Chef med team- och/eller personalansvar"],
    "c_level": ["C-level executive", "Chef på C-nivå"],
    "title": ["Title", "Titel"],
    "coaching-areas-of-interest": ["Coaching areas of interest", "Coachområden av intresse"],
    "experience-of-being-coached": ["Experience of being coached", "Erfarenhet av att ha haft coaching"],
    "executive_coaching": ["Executive coaching", "Chefscoaching"],
    "team_coaching": ["Team coaching", "Teamcoaching"],
    "leadership_coaching": ["Leadership coaching", "Ledarskapscoaching"],
    "business_coaching": ["Business coaching", "Affärscoaching"],
    "agile_coaching": ["Agile coaching", "Agil coaching"],
    "inclusive_corporate_culture": ["Inclusive corporate culture", "Inkluderande företagskultur"],
    "lifestyle_health": ["Lifestyle and health", "Livsstil och hälsa"],
    "stress_management": ["Stress management", "Stresshantering"],
    "life_coaching": ["Life coaching", "Livscoaching"],
    "mental_training": ["Mental training", "Mental träning"],
    "self_leadership": ["Self-leadership", "Självledarskap"],
    "rehabilitation": ["Rehabilitation", "Rehabilitering"],
    "career_coaching": ["Career coaching", "Karriärcoaching"],
    "transit_coaching": ["Transit coaching", "Transitcoaching"],
    "mentorship": ["Mentorship", "Mentorskap"],
    "self-assessment": ["Self-assessment", "Självskattning"],
    "feedback-score": ["Feedback", "Feedback"],
    "perception-gap": ["Perception gap", "Gap"],
    "read-more": ["Read more", "Läs mer"],
    "read-less": ["Read less", "Läs mindre"],
    "analysis": ["Analysis", "Analys"],
    "write-text-here": ["Write text here...", "Skriv text här..."],
    "yes": ["Yes", "Ja"],
    "synced-calendars": ["Synced calendars", "Synkade kalendrar"],
    "send": ["Send", "Skicka"],
    "summary": ["Summary", "Sammanställning"],
    "notes": ["Notes", "Anteckningar"],
    "client": ["Client", "Klient"],
    "chat-placeholder": ["Type your message here...", "Skriv ditt meddelande här..."],
    "support-modal-success-title": ["Thank you for reaching out to us! ", "Tack för att du kontaktar oss! "],
    "support-modal-success-description": ["We will get back to you as soon as possible.", "Vi återkommer så snart som möjligt."],
    "support-error-message": ["An error occurred, please try again later.", "Ett fel uppstod, försök igen senare."],
    "goal": ["Goal", "Mål"],
    "description": ["Description", "Beskrivning"],
    "details": ["Details", "Details"],
    "starting-point": ["Assess your starting point", "Startläge"],
    "importance-level": ["Importance level", "Hur viktigt är målet"],
    "success-metrics": ["Success metrics", "Mått för framgång"],
    "target-date": ["Target date", "Måldatum"],
    "goal-journey": ["Goal journey", "Målets resa"],
    "set-your-goal": ["Set your goal", "Sätt ditt mål"],
    "set-your-goal-text": ["Define what success looks like for you.", "Definiera vad framgång betyder för dig"],
    "stay-on-track": ["Check in", "Håll dig på rätt spår"],
    "stay-on-track-text": [
      "Check in regularly to remove blockers, and gather feedback from your colleagues.",
      "Kontrollera ofta och ta bort hinder"
    ],
    "get-feedback-along-the-way": ["Follow up", "Få feedback längs vägen"],
    "get-feedback-along-the-way-text": [
      "Reflect on your journey and send a new feedback request to see how your progress is perceived and what you can improve.",
      "Skapa medvetenhet om din process och justera din strategi vid behov"
    ],
    "decide-whats-next": ["Decide what's next","Bestäm vad som är nästa steg"],
    "decide-whats-next-text": ["Set a new goal, or start a new Focus Area","Sätt ett nytt mål eller starta ett nytt fokusområde"],
    "set-goal-description": [
      "Setting a clear goal gives you direction, keeps you focused, and aligns your efforts with what truly matters—driving meaningful progress.",
      "Att sätta ett tydligt mål ger dig riktning, håller dig fokuserad och anpassar dina ansträngningar med det som verkligen betyder något – att driva meningsfulla framsteg."
    ],
    "coaching-tools": ["Coaching tools", "Coachingverktyg"],
    "focus-area": ["Focus area", "Fokusområde"],
    "book": ["Book", "Boka"],
    "profile": ["Profile", "Profil"],
    "personality-test": ["Personality test", "Personlighetstest"],
    "stress-test": ["Stress test", "Stresstest"],
    "sub-goals": ["Sub Goals", "Delmål"],
    "due-date": ["Due date", "Slutdatum"],
}

const english: {[id: string]: string} = {}
const swedish:{[id: string]: string} = {}
for (const k in langMap) {
    english[k] = langMap[k][0]
    swedish[k] = langMap[k][1]
}

const resources: any = {
    en: {
        translation: english
    },
    sv: {
        translation: swedish
    },
}

const selectedLng = localStorage.getItem('language') === 'sv' ? 'sv' : 'en'

i18n.use(initReactI18next).init({
    resources: resources,
    lng: selectedLng,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    debug: false,
})

export default i18n;
